import { Combo } from './combo';

export class userDemo{
    constructor(
        public tipDocumento: any,
        public numeroDocumento: any,
        public tipoExamen: Combo,
    ){}
}